export default __webpack_public_path__ + "static/media/avatar_4.0c7e848a.svg";